<template>
  <div class="wrapper-content w-100">
    <h1>{{$t(viewInfo.title)}}</h1>
    <LmBreadcrumb showBreadcrumb/>
    <form
      @submit.prevent="submit"
      novalidate
      class="position-relative">
      <LmNumberInput
        v-model="form.idCupon"
        :v="$v.form.idCupon"
        label="Id cupon"
        placeholder="Id cupon"
        />
      <LmNumberInput
        v-model="form.idMarca"
        :v="$v.form.idMarca"
        label="Id marca"
        placeholder="Id marca"
        />
      <LmTextInput
        v-model="form.codigo"
        :v="$v.form.codigo"
        label="Codigo"
        placeholder="Codigo"
        />
      <LmSelect
        v-model="form.quemado"
        :v="$v.form.quemado"
        :options="quemadoOptions"
        label="Quemado"
        />
      <LmNumberInput
        v-model="form.numeroTarjeta"
        :v="$v.form.numeroTarjeta"
        label="Numero tarjeta"
        placeholder="Numero tarjeta"
        />
      <LmDateTime
        v-model="form.fQuemado"
        :v="$v.form.fQuemado"
        placeholder="F Quemado"
        label="F Quemado"
        />
      <LmDateTime
        v-model="form.fDesde"
        :v="$v.form.fDesde"
        placeholder="F Desde"
        label="F Desde"
        />
      <LmDateTime
        v-model="form.fHasta"
        :v="$v.form.fHasta"
        placeholder="F Hasta"
        label="F Hasta"
        />
      <LmSelect
        v-model="form.nombreValidador"
        :v="$v.form.nombreValidador"
        :options="nombreValidadorOptions"
        label="Nombre Validador"
        />
      <LmSelect
        v-model="form.nombreValidador2"
        :v="$v.form.nombreValidador2"
        :options="nombreValidador2Options"
        label="Nombre validador 2"
        />
      <LmButton
        type="submit"
        buttonClass="btn-primary"
        :isProcessing="formIsProcessing"
        :value="$t('Save')"
        lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col"
        />
      <LmButton
        type="button"
        buttonClass="btn-secondary"
        :value="$t('Cancel')"
        @click.native="cancelBtn"
        lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col"
        />
        <LmComponentLoading v-if="loading" />
    </form>
    <!-- <b-modal
      id="confirmModal"
      ref="confirmModal"
      :title="$t('are_you_sure')"
      title-tag="h3"
      :cancel-title="$t('Cancel')"
      :ok-title="$t('Ok')"
      centered
      lazy
      @ok="confirmModalOk"
      >
      <p>{{$t('sure_leave_page_coupon')}}</p>
    </b-modal> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmEmailInput from '@/components/form/elements/LmEmailInput'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmNumberInput from '@/components/form/elements/LmNumberInput'
import LmTextArea from '@/components/form/elements/LmTextArea'
import LmSelect from '@/components/form/elements/LmSelect'
import LmDateTime from '@/components/form/elements/LmDateTime'
import LmDate from '@/components/form/elements/LmDate'
import LmButton from '@/components/form/elements/LmButton'
import LmComponentLoading from '@/components/LmComponentLoading'
import resetForm from '@/helpers/form.js'

export default {
  components: {
    LmTextInput,
    LmNumberInput,
    LmEmailInput,
    LmButton,
    LmTextArea,
    LmSelect,
    LmDateTime,
    LmDate,
    LmComponentLoading
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      quemadoOptions: {
        disabledOption: 'Please select an option',
        content: ['Yes', 'No']
      },
      nombreValidadorOptions: {
        disabledOption: 'Please select a Nombre validador',
        content: ['Buquebus', 'validador-dafiti', 'cyber365-dafiti']
      },
      nombreValidador2Options: {
        disabledOption: 'Please select a Nombre validador 2',
        content: ['Buquebus2', 'validador-dafiti2', 'cyber365-dafiti2']
      },
      form: {
        idCupon: null,
        idMarca: null,
        codigo: '',
        quemado: null,
        numeroTarjeta: null,
        fQuemado: null,
        fDesde: null,
        fHasta: null,
        nombreValidador: null,
        nombreValidador2: null
      },
      formIsProcessing: false
    }
  },
  computed: {
    ...mapState('commons', ['itemDetail', 'loading']),
    viewInfo: function () {
      return {
        view: this.isOnEditMode ? 'Edit' : 'New',
        title: this.isOnEditMode ? 'Edit' : 'New'
      }
    },
    apiCall () {
      return {
        path: this.isOnEditMode ? 'coupons/detail' : null,
        id: this.isOnEditMode ? this.$route.params.id : null
      }
    },
    isOnEditMode () {
      return this.$route.name === 'coupons_edit'
    }
  },
  props: {
    id: {
      type: String
    }
  },
  validations: {
    form: {
      idCupon: {
        required
      },
      idMarca: {
        required
      },
      codigo: {
        required
      },
      quemado: {
        required
      },
      numeroTarjeta: {
        required
      },
      fQuemado: {
        required
      },
      fDesde: {
        required
      },
      fHasta: {
        required
      },
      nombreValidador: {
        required
      },
      nombreValidador2: {
        // required
      }
    }
  },
  methods: {
    ...mapActions('commons', ['getItemDetail']),
    cancelBtn () {
      alert('Cancel!')
    },
    submit () {
      this.formIsProcessing = true
      this.$v.form.$touch()
      setTimeout(() => {
        if (this.$v.form.$pending || this.$v.form.$error) {
          this.formIsProcessing = true
          alert('Forms error')
          this.formIsProcessing = false
          return
        }
        alert('Form submitted')
        this.$router.push('/coupons/list')
      }, 3000)
    }
  },
  created () {
    if (this.isOnEditMode) {
      const getCouponActionAsync = async () => {
        await this.getItemDetail(this.apiCall)
        this.form.idCupon = Number(this.itemDetail.id_cupon)
        this.form.idMarca = Number(this.itemDetail.id_marca)
        this.form.codigo = this.itemDetail.codigo
        this.form.quemado = this.itemDetail.quemado ? 'Yes' : 'No'
        this.form.numeroTarjeta = Number(this.itemDetail.numero_tarjeta)
        this.form.fQuemado = this.itemDetail.f_quemado
        this.form.fDesde = this.itemDetail.f_desde
        this.form.fHasta = this.itemDetail.f_hasta
        this.form.nombreValidador = this.itemDetail.nombre_validador
        this.form.nombreValidador2 = this.itemDetail.nombre_validador2
      }
      getCouponActionAsync()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.$v.$anyError) {
      if (confirm(this.$t('sure_leave_page'))) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'coupons_new') {
        resetForm(this.form)
        setTimeout(() => {
          this.$v.form.$reset()
        }, 50)
      }
    }
  }
}
</script>

/*
TODO:
  * Acordar con backend como vamos a traer los valores options de los selects. https://github.com/lumile/lumbre/issues/137#issuecomment-456820475
  * Mostrar un mensaje adecuado cuando el formulario se guard y otro cuando el formulario falla (actualmente se muestran errores indivicuales pero no el general)
  * Acordar con Backend las validaciones específica de cada input.
  * Seria bueno que la utilidad reset form puda utilizar la función $v.form.$reset() asi mejorar su reusablidad.
  * Seria bueno encontrar una forma más prolija de asignar lo valores al formulario cuando se edita. Quizás podria ayudar acordar nombres para los campos de la api y typos de datos para evitar hacer trasformaciones de tipos y mejorar el rendimiento y el mantenimiento.
  * Reemplazar el confirm por un modal
  * Resolver el hack del setTimeout y $reset
  * Encontrar la forma de reutilizar el submit
*/
